(function () {
  'use strict';

  /* @ngdoc object
   * @name patternLimitation
   * @description
   *
   */
  angular
    .module('patternLimitation', [
      'ui.router'
    ]);
}());
